export default __webpack_public_path__ + "static/media/ziyoushijiao.4e932cff.png";